// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"Checkbox_CheckboxInput__sJWC1"};